import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2, Clock, ShieldCheck, CreditCard, Star, ChevronDown, ChevronUp, FileText, Zap, BookOpen, Trophy, Gift, Target, Users, Activity, PlayCircle, X } from 'lucide-react';
// --- MOCK DATA ---
const MAIN_IMAGE = 'https://cdn.magicpatterns.com/uploads/abbTk8J3GZ1AhzinVd3BAr/MUCKUP_HANDBALL.png';
const RECENT_PURCHASES = [{
  name: 'Juan M.',
  city: 'Córdoba'
}, {
  name: 'Martina S.',
  city: 'Buenos Aires'
}, {
  name: 'Diego L.',
  city: 'Rosario'
}, {
  name: 'Carla P.',
  city: 'Mendoza'
}, {
  name: 'Lucas G.',
  city: 'Santa Fe'
}];
// --- COMPONENTS ---
const PurchasePopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [purchase, setPurchase] = useState(RECENT_PURCHASES[0]);
  useEffect(() => {
    const interval = setInterval(() => {
      const randomPurchase = RECENT_PURCHASES[Math.floor(Math.random() * RECENT_PURCHASES.length)];
      setPurchase(randomPurchase);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    }, 30000); // Mostrar cada 30 segundos
    return () => clearInterval(interval);
  }, []);
  return <AnimatePresence data-id="element-2">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      x: -20
    }} className="fixed bottom-4 left-4 z-50 bg-white rounded-lg shadow-xl border border-gray-100 p-4 flex items-center gap-4 max-w-sm" data-id="element-3">
          <div className="bg-blue-100 p-2 rounded-full text-blue-600" data-id="element-4">
            <CheckCircle2 size={24} data-id="element-5" />
          </div>
          <div data-id="element-6">
            <p className="text-sm font-medium text-gray-900" data-id="element-7">
              {purchase.name} de {purchase.city}
            </p>
            <p className="text-xs text-gray-500" data-id="element-8">
              Acaba de comprar el Megapack Elite
            </p>
          </div>
          <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-9">
            <X size={14} data-id="element-10" />
          </button>
        </motion.div>}
    </AnimatePresence>;
};
const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 37
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <div className="flex justify-center gap-4 text-center" data-id="element-11">
      <div className="bg-red-600 text-white rounded-lg p-3 w-20" data-id="element-12">
        <div className="text-3xl font-bold" data-id="element-13">
          {String(timeLeft.hours).padStart(2, '0')}
        </div>
        <div className="text-xs uppercase tracking-wider mt-1" data-id="element-14">HS</div>
      </div>
      <div className="text-3xl font-bold text-red-600 self-center" data-id="element-15">:</div>
      <div className="bg-red-600 text-white rounded-lg p-3 w-20" data-id="element-16">
        <div className="text-3xl font-bold" data-id="element-17">
          {String(timeLeft.minutes).padStart(2, '0')}
        </div>
        <div className="text-xs uppercase tracking-wider mt-1" data-id="element-18">MIN</div>
      </div>
      <div className="text-3xl font-bold text-red-600 self-center" data-id="element-19">:</div>
      <div className="bg-red-600 text-white rounded-lg p-3 w-20" data-id="element-20">
        <div className="text-3xl font-bold" data-id="element-21">
          {String(timeLeft.seconds).padStart(2, '0')}
        </div>
        <div className="text-xs uppercase tracking-wider mt-1" data-id="element-22">SEG</div>
      </div>
    </div>;
};
const FAQItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-gray-200 py-4" data-id="element-23">
      <button onClick={() => setIsOpen(!isOpen)} className="flex w-full items-center justify-between text-left focus:outline-none" data-id="element-24">
        <span className="font-semibold text-gray-900" data-id="element-25">{question}</span>
        {isOpen ? <ChevronUp className="h-5 w-5 text-blue-600" data-id="element-26" /> : <ChevronDown className="h-5 w-5 text-gray-400" data-id="element-27" />}
      </button>
      <AnimatePresence data-id="element-28">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="overflow-hidden" data-id="element-29">
            <p className="mt-4 text-gray-600 leading-relaxed" data-id="element-30">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
const PACKS = [{
  id: 'rendimiento',
  icon: '📗',
  name: 'PACK RENDIMIENTO 360',
  contents: 'Tomos 1 al 14 + 6 Bonus',
  oldPrice: '$34.990',
  price: '$18.990',
  cta: 'QUIERO PACK RENDIMIENTO',
  note: 'Ideal para entrenadores de Juveniles, Juniors y Mayores',
  checkoutUrl: 'https://profelisto.com.ar/checkouts/cn/hWNDjKL4oZyHcw4CdWAtEByE/es-ar?_r=AQAB0dE97SE1CGBHk-_CammKn6N-y9u_Ept5IS4HEVt1Akc'
}, {
  id: 'megapack',
  icon: '🏆',
  name: 'MEGAPACK HANDBALL 360 ELITE',
  contents: '14 Tomos + 6 Bonus + 2 EBOOKS ELITE',
  oldPrice: '$49.990',
  price: '$27.990',
  cta: 'SÍ, QUIERO EL MEGAPACK ELITE',
  note: 'La opción más elegida por entrenadores de handball argentinos',
  best: true,
  badge: '⭐ MÁS ELEGIDO',
  save: 'AHORRÁS $22.000',
  checkoutUrl: 'https://profelisto.com.ar/checkouts/cn/hWNDjKLFRSPnhbdzwJwsQMZW/es-ar?_r=AQABhweKUdcl1tb8_iA5ufjaqb3TFcUoH_BWx5PutOwY6DY'
}];
export function LandingPage() {
  const [selectedPack, setSelectedPack] = useState('megapack');
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const activePack = PACKS.find(p => p.id === selectedPack) ?? PACKS[PACKS.length - 1];
  return <div className="min-h-screen bg-gray-50 font-sans text-gray-900 selection:bg-blue-200" data-id="element-31">
      <PurchasePopup data-id="element-32" />

      {/* SECCIÓN 1 — HERO / CABECERA */}
      <header className="bg-[#f7f4ef] text-gray-900 min-h-[100svh] flex flex-col justify-center py-8 sm:py-16 px-4 relative overflow-hidden" data-id="element-33">
        <div className="max-w-3xl mx-auto relative z-10 text-center w-full" data-id="element-34">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-35">
            <p className="text-blue-700 text-xs sm:text-sm font-bold tracking-[0.2em] uppercase mb-3 sm:mb-5" data-id="element-36">
              PROFE LISTO · HANDBALL 360
            </p>
            <h1 className="text-3xl sm:text-5xl md:text-6xl font-extrabold leading-[1.1] tracking-tight mb-5 sm:mb-8 text-gray-900" data-id="element-37">
              Todo tu año de handball resuelto de una vez.
            </h1>

            <motion.div initial={{
            opacity: 0,
            scale: 0.92
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="relative mb-5 sm:mb-8 max-w-[220px] sm:max-w-md mx-auto" data-id="element-38">
              <img src={MAIN_IMAGE} alt="Megapack Handball 360 — Pack Anual Elite Completo" className="w-full drop-shadow-2xl" width={1080} height={1400} loading="eager" fetchPriority="high" decoding="async" data-id="element-39" />
            </motion.div>

            <p className="text-sm sm:text-lg text-gray-500 mb-5 sm:mb-8 leading-relaxed max-w-xl mx-auto" data-id="element-40">
              Megapack HANDBALL 360 — El sistema completo de sesiones y
              planificación para el entrenador de handball argentino.
            </p>

            {/* Pills de features */}
            <div className="flex flex-wrap items-center justify-center gap-2 sm:gap-3 mb-6 sm:mb-8" data-id="element-41">
              <span className="inline-flex items-center gap-1.5 bg-white border border-gray-200 shadow-sm rounded-full px-3 py-1.5 text-xs sm:text-sm font-medium text-gray-700" data-id="element-42">
                📄 PDF
              </span>
              <span className="inline-flex items-center gap-1.5 bg-white border border-gray-200 shadow-sm rounded-full px-3 py-1.5 text-xs sm:text-sm font-medium text-gray-700" data-id="element-43">
                ⚡ Acceso Inmediato
              </span>
              <span className="inline-flex items-center gap-1.5 bg-white border border-gray-200 shadow-sm rounded-full px-3 py-1.5 text-xs sm:text-sm font-medium text-gray-700" data-id="element-44">
                📚 14 Tomos + 6 Bonus + 2 Elite
              </span>
            </div>

            <button onClick={scrollToPricing} className="w-full sm:w-auto bg-yellow-400 hover:bg-yellow-300 text-blue-900 font-bold text-base sm:text-lg py-4 px-10 rounded-2xl shadow-lg shadow-yellow-400/30 transition-all transform hover:scale-[1.02] inline-flex items-center justify-center gap-2" data-id="element-45">
              💪 QUIERO MI HANDBALL 360 AHORA
            </button>

            {/* Señales de confianza */}
            <div className="mt-6 sm:mt-8 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs sm:text-sm text-gray-600" data-id="element-46">
              <span className="inline-flex items-center gap-1.5" data-id="element-47">
                <ShieldCheck size={16} className="text-blue-600" data-id="element-48" /> Garantía 7
                días
              </span>
              <span className="text-gray-300" data-id="element-49">|</span>
              <span className="inline-flex items-center gap-1.5" data-id="element-50">
                <ShieldCheck size={16} className="text-blue-600" data-id="element-51" /> Pago seguro
              </span>
              <span className="text-gray-300" data-id="element-52">|</span>
              <span className="inline-flex items-center gap-1.5" data-id="element-53">
                <CreditCard size={16} className="text-blue-600" data-id="element-54" /> Tarjetas y
                transferencia
              </span>
            </div>
          </motion.div>
        </div>
      </header>

      {/* BARRA DE ESTADÍSTICAS */}
      <section className="bg-blue-900 text-white py-12 sm:py-16 px-4" data-id="element-55">
        <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-56">
          <div data-id="element-57">
            <div className="text-4xl sm:text-5xl font-extrabold tracking-tight" data-id="element-58">
              +300
            </div>
            <div className="text-sm sm:text-base text-yellow-400 mt-2" data-id="element-59">
              profes confían
            </div>
          </div>
          <div data-id="element-60">
            <div className="text-4xl sm:text-5xl font-extrabold tracking-tight" data-id="element-61">
              14+6
            </div>
            <div className="text-sm sm:text-base text-yellow-400 mt-2" data-id="element-62">
              Tomos + Bonus
            </div>
          </div>
          <div data-id="element-63">
            <div className="text-4xl sm:text-5xl font-extrabold tracking-tight" data-id="element-64">
              4.9/5
            </div>
            <div className="text-sm sm:text-base text-yellow-400 mt-2" data-id="element-65">
              calificación ⭐
            </div>
          </div>
          <div data-id="element-66">
            <div className="text-4xl sm:text-5xl" data-id="element-67">🇦🇷</div>
            <div className="text-sm sm:text-base text-yellow-400 mt-2" data-id="element-68">
              Argentina
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 2 — TESTIMONIOS INICIALES */}
      <section className="py-16 bg-white relative z-20 max-w-6xl mx-auto rounded-3xl shadow-xl px-4 sm:px-8 mt-12" data-id="element-69">
        <div className="grid md:grid-cols-3 gap-8" data-id="element-70">
          <div className="bg-gray-50 p-6 rounded-2xl border border-gray-100" data-id="element-71">
            <div className="flex text-yellow-400 mb-4" data-id="element-72">
              {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-73" />)}
            </div>
            <p className="text-gray-700 italic mb-6" data-id="element-74">
              "Organicé todo el mes en una tarde. Nunca más llego al entreno sin
              saber qué dar."
            </p>
            <div className="flex items-center gap-3" data-id="element-75">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-700 font-bold" data-id="element-76">
                MP
              </div>
              <div data-id="element-77">
                <div className="font-bold text-gray-900" data-id="element-78">
                  Marcos P., Buenos Aires
                </div>
                <div className="text-xs text-gray-500" data-id="element-79">
                  Entrenador de Club de Barrio
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 p-6 rounded-2xl border border-gray-100" data-id="element-80">
            <div className="flex text-yellow-400 mb-4" data-id="element-81">
              {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-82" />)}
            </div>
            <p className="text-gray-700 italic mb-6" data-id="element-83">
              "Mis Cadetes mejoraron la defensa desde la primera semana usando
              el Tomo 7."
            </p>
            <div className="flex items-center gap-3" data-id="element-84">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-700 font-bold" data-id="element-85">
                CG
              </div>
              <div data-id="element-86">
                <div className="font-bold text-gray-900" data-id="element-87">
                  Claudia G., Córdoba
                </div>
                <div className="text-xs text-gray-500" data-id="element-88">
                  Profesora de Educación Física
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 p-6 rounded-2xl border border-gray-100" data-id="element-89">
            <div className="flex text-yellow-400 mb-4" data-id="element-90">
              {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-91" />)}
            </div>
            <p className="text-gray-700 italic mb-6" data-id="element-92">
              "Antes tardaba 2 horas armando el entrenamiento. Ahora son 5
              minutos."
            </p>
            <div className="flex items-center gap-3" data-id="element-93">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-700 font-bold" data-id="element-94">
                FR
              </div>
              <div data-id="element-95">
                <div className="font-bold text-gray-900" data-id="element-96">
                  Federico R., Rosario
                </div>
                <div className="text-xs text-gray-500" data-id="element-97">
                  Coordinador de Handball Infantil
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 3 — DOLOR / IDENTIFICACIÓN */}
      <section className="py-24 px-4 bg-gray-50" data-id="element-98">
        <div className="max-w-3xl mx-auto" data-id="element-99">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-900" data-id="element-100">
            Si sos entrenador de handball, <br data-id="element-101" />
            <span className="text-blue-600" data-id="element-102">esto te va a sonar conocido:</span>
          </h2>

          <div className="space-y-4 mb-12" data-id="element-103">
            {['Llegás al entreno sin saber exactamente qué ejercicios vas a dar', 'Tus jugadores no progresan porque no hay un orden claro de contenidos', 'Tenés categorías con niveles mezclados y no sabés cómo manejarlas al mismo tiempo', 'Cuando falta un jugador o hay partido perdés la continuidad de la planificación', 'No podés demostrar el progreso de tus jugadores porque no tenés nada sistematizado', 'El arquero entrena solo contra la pared mientras vos atendés al resto del grupo', 'Nadie valora tu trabajo porque los resultados no se ven en la cancha', 'Llegás al partido sin jugadas preparadas y el banco de suplentes se transforma en silencio cuando más necesitás ideas'].map((pain, idx) => <div key={idx} className="flex items-start gap-4 bg-white p-4 rounded-xl shadow-sm border border-gray-100" data-id="element-104">
                <div className="mt-1 bg-red-100 text-red-600 p-1 rounded-full flex-shrink-0" data-id="element-105">
                  <X size={16} data-id="element-106" />
                </div>
                <p className="text-gray-700 font-medium" data-id="element-107">{pain}</p>
              </div>)}
          </div>

          <div className="text-center bg-blue-900 text-white p-8 rounded-2xl shadow-xl" data-id="element-108">
            <h3 className="text-2xl font-bold mb-6" data-id="element-109">
              "¿Cuántos entrenamientos más vas a improvisar?"
            </h3>
            <button onClick={scrollToPricing} className="w-full sm:w-auto bg-yellow-400 hover:bg-yellow-300 text-blue-900 font-bold text-lg py-4 px-8 rounded-xl transition-all transform hover:scale-105 flex items-center justify-center gap-2 mx-auto shadow-lg shadow-yellow-400/30" data-id="element-110">
              👉 BASTA DE IMPROVISAR — QUIERO MI HANDBALL 360
            </button>
          </div>
        </div>
      </section>

      {/* SECCIÓN 4 & 5 — PRESENTACIÓN DEL PRODUCTO Y LOS 14 TOMOS */}
      <section className="py-24 px-4 bg-white" data-id="element-111">
        <div className="max-w-5xl mx-auto" data-id="element-112">
          <div className="text-center mb-16" data-id="element-113">
            <div className="inline-flex items-center justify-center p-4 bg-blue-100 text-blue-700 rounded-full mb-6" data-id="element-114">
              <Trophy size={48} data-id="element-115" />
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6" data-id="element-116">
              El Sistema N°1 para Entrenadores de Handball Argentinos
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-117">
              HANDBALL 360 — Colección Completa. 14 Tomos + 6 Bonus + 2 Elite.
              Todo resuelto. Todas las categorías.
            </p>

            <div className="flex flex-wrap justify-center gap-6 mt-8" data-id="element-118">
              <div className="bg-blue-50 text-blue-800 px-6 py-3 rounded-full font-bold" data-id="element-119">
                +310 páginas
              </div>
              <div className="bg-blue-50 text-blue-800 px-6 py-3 rounded-full font-bold" data-id="element-120">
                +728 sesiones resueltas
              </div>
              <div className="bg-blue-50 text-blue-800 px-6 py-3 rounded-full font-bold" data-id="element-121">
                De Minis a Mayores
              </div>
            </div>
          </div>

          <div className="bg-blue-950 text-white rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-122">
            <h3 className="text-3xl font-bold mb-2 text-center" data-id="element-123">
              Los 14 Tomos Completos
            </h3>
            <p className="text-gray-400 text-center mb-12" data-id="element-124">
              Sesiones resueltas · Por categoría y edad · Listo para usar mañana
            </p>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-125">
              {[{
              title: 'TOMO 1',
              cat: 'Minis — Semanas 1 a 26',
              desc: '"El Año del Despertar Motor". Familiarización con el balón, coordinación y primeros pasos en el juego colectivo.'
            }, {
              title: 'TOMO 2',
              cat: 'Minis — Semanas 27 a 52',
              desc: '"El Año del Juego Colectivo". Roles tácticos básicos, defensa grupal y torneos internos preparatorios.'
            }, {
              title: 'TOMO 3',
              cat: 'Infantiles — Semanas 1 a 26',
              desc: '"El Año de la Técnica Individual". Ciclo de pasos, lanzamiento en suspensión, pase y recepción técnica avanzada.'
            }, {
              title: 'TOMO 4',
              cat: 'Infantiles — Semanas 27 a 52',
              desc: 'Consolidación técnica, 1vs1 ofensivo y defensivo, lectura del defensor.'
            }, {
              title: 'TOMO 5',
              cat: 'Menores — Semanas 1 a 26',
              desc: 'Iniciación táctica, sistemas defensivos básicos y combinaciones de ataque.'
            }, {
              title: 'TOMO 6',
              cat: 'Menores — Semanas 27 a 52',
              desc: 'Consolidación táctica, contraataque y juego en superioridad numérica inicial.'
            }, {
              title: 'TOMO 7',
              cat: 'Cadetes — Semanas 1 a 26',
              desc: 'Sistemas defensivos 6:0 y 5:1, ataque posicional y circulación de balón.'
            }, {
              title: 'TOMO 8',
              cat: 'Cadetes — Semanas 27 a 52',
              desc: 'Táctica avanzada de Cadetes, jugadas de pizarrón básicas y preparación competitiva.'
            }, {
              title: 'TOMO 9',
              cat: 'Juveniles — Semanas 1 a 26',
              desc: 'Consolidación del sistema de juego, intensidad competitiva y liderazgo en cancha.'
            }, {
              title: 'TOMO 10',
              cat: 'Juveniles — Semanas 27 a 52',
              desc: 'Alta competencia juvenil, análisis táctico y preparación para el salto a Juniors.'
            }, {
              title: 'TOMO 11',
              cat: 'Juniors — Semanas 1 a 26',
              desc: 'Handball de alto rendimiento amateur, sistemas complejos y gestión del partido.'
            }, {
              title: 'TOMO 12',
              cat: 'Juniors — Semanas 27 a 52',
              desc: 'Consolidación del modelo de juego, preparación física integrada y campeonatos.'
            }, {
              title: 'TOMO 13',
              cat: 'Mayores — Semanas 1 a 26',
              desc: 'Rendimiento sostenible, recuperación activa y gestión del grupo adulto.'
            }, {
              title: 'TOMO 14',
              cat: 'Mayores — Semanas 27 a 52',
              desc: 'Pico de forma competitivo, táctica de elite y cierre de temporada.'
            }].map((tomo, idx) => <div key={idx} className="bg-blue-800 p-6 rounded-xl border border-blue-700 hover:border-yellow-400 transition-colors" data-id="element-126">
                  <div className="text-yellow-400 font-bold text-sm mb-1" data-id="element-127">
                    {tomo.title}
                  </div>
                  <div className="text-white font-bold text-lg mb-2" data-id="element-128">
                    {tomo.cat}
                  </div>
                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-129">
                    {tomo.desc}
                  </p>
                </div>)}
            </div>

            <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4 text-center border-t border-blue-800 pt-8" data-id="element-130">
              <div data-id="element-131">
                <div className="text-2xl mb-2" data-id="element-132">✏️</div>
                <div className="text-sm font-medium" data-id="element-133">Sesiones detalladas</div>
              </div>
              <div data-id="element-134">
                <div className="text-2xl mb-2" data-id="element-135">⚡</div>
                <div className="text-sm font-medium" data-id="element-136">
                  Sistema "Abrí y Entrenás"
                </div>
              </div>
              <div data-id="element-137">
                <div className="text-2xl mb-2" data-id="element-138">📋</div>
                <div className="text-sm font-medium" data-id="element-139">
                  Planillas listas para imprimir
                </div>
              </div>
              <div data-id="element-140">
                <div className="text-2xl mb-2" data-id="element-141">🇦🇷</div>
                <div className="text-sm font-medium" data-id="element-142">
                  100% adaptado a Argentina
                </div>
              </div>
            </div>
          </div>

          <div className="mt-12 text-center" data-id="element-143">
            <button onClick={scrollToPricing} className="bg-blue-600 hover:bg-blue-700 text-white font-bold text-lg py-4 px-8 rounded-xl shadow-lg transition-all transform hover:scale-105 inline-flex items-center justify-center gap-2" data-id="element-144">
              VER PLANES Y PRECIOS
            </button>
          </div>
        </div>
      </section>

      {/* SECCIÓN 6 — LOS 6 BONUS */}
      <section className="py-24 px-4 bg-gray-50 border-y border-gray-200" data-id="element-145">
        <div className="max-w-5xl mx-auto" data-id="element-146">
          <div className="text-center mb-16" data-id="element-147">
            <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-4" data-id="element-148">
              + 6 Regalos Estratégicos
            </h2>
            <p className="text-xl text-gray-600" data-id="element-149">
              Incluidos sin costo extra · Valor real del pack
            </p>
            <div className="inline-block mt-4 bg-red-100 text-red-700 font-bold px-4 py-2 rounded-full animate-pulse" data-id="element-150">
              🎁 GRATIS POR EL DÍA DE HOY
            </div>
          </div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-151">
            {[{
            icon: '🔥',
            title: 'CALENTAMIENTO 360',
            desc: '18 protocolos de activación con pelota desde el minuto 1. De Minis a Mayores.',
            cover: 'bg-orange-500',
            spine: 'bg-orange-600'
          }, {
            icon: '💪',
            title: 'PREPARACIÓN FÍSICA EXPRESS',
            desc: '15 minutos. Sin sala. Sin pesas. Física integrada al entrenamiento real.',
            cover: 'bg-blue-500',
            spine: 'bg-blue-600'
          }, {
            icon: '🥗',
            title: 'NUTRICIÓN Y RENDIMIENTO',
            desc: 'Qué comer antes, durante y después. Guía lista para enviar a los padres.',
            cover: 'bg-emerald-500',
            spine: 'bg-emerald-600'
          }, {
            icon: '🔍',
            title: 'SCOUTING Y ANÁLISIS RIVAL',
            desc: 'El método de los 3 minutos para leer al rival y ganar el partido antes de jugarlo.',
            cover: 'bg-indigo-500',
            spine: 'bg-indigo-600'
          }, {
            icon: '🛠️',
            title: 'KIT DE SUPERVIVENCIA',
            desc: '8 protocolos para los días de caos. Sin materiales, grupo mixto, 20 minutos: resuelto.',
            cover: 'bg-red-500',
            spine: 'bg-red-600'
          }, {
            icon: '📋',
            title: 'PACK DE ORGANIZACIÓN SEMANAL',
            desc: 'Planillas de asistencia, cobros e inventario. Dominá tu semana en 15 minutos cada domingo.',
            cover: 'bg-teal-500',
            spine: 'bg-teal-600'
          }].map((bonus, idx) => <div key={idx} className="bg-white rounded-3xl shadow-lg border border-gray-100 flex flex-col items-center text-center p-8" data-id="element-152">
                {/* Portada del libro */}
                <div className="relative w-44 h-60 mb-6" data-id="element-153">
                  <div className={`absolute inset-0 ${bonus.cover} rounded-r-lg rounded-l-sm shadow-xl overflow-hidden`} data-id="element-154">
                    {/* Lomo del libro */}
                    <div className={`absolute left-0 top-0 bottom-0 w-3 ${bonus.spine}`} data-id="element-155" />
                    <div className="absolute left-3 top-0 bottom-0 w-1.5 bg-black/10" data-id="element-156" />
                    {/* Contenido de la portada */}
                    <div className="relative h-full flex flex-col text-left text-white pl-7 pr-5 py-6" data-id="element-157">
                      <span className="text-4xl drop-shadow" data-id="element-158">{bonus.icon}</span>
                      <div className="flex-1" data-id="element-159" />
                      <div className="text-2xl font-extrabold leading-tight" data-id="element-160">
                        Bonus {idx + 1}
                      </div>
                      <div className="h-px bg-white/30 my-3" data-id="element-161" />
                      <div className="text-[11px] font-semibold tracking-[0.2em] text-white/80" data-id="element-162">
                        HANDBALL 360™
                      </div>
                    </div>
                  </div>
                </div>

                {/* Sello GRATIS */}
                <span className="bg-green-100 text-green-700 text-sm font-bold px-5 py-1.5 rounded-full mb-4" data-id="element-163">
                  GRATIS
                </span>

                {/* Título */}
                <h4 className="text-xl font-bold text-gray-900 mb-3" data-id="element-164">
                  {bonus.icon} Bonus {idx + 1} — {bonus.title}
                </h4>

                {/* Descripción */}
                <p className="text-gray-600" data-id="element-165">{bonus.desc}</p>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECCIÓN 7, 8, 9, 11 — PRECIOS Y OFERTAS */}
      <section id="pricing" className="py-24 px-4 bg-white relative" data-id="element-166">
        <div className="max-w-6xl mx-auto" data-id="element-167">
          <div className="text-center mb-12" data-id="element-168">
            <div className="inline-block bg-red-100 text-red-700 font-bold px-6 py-2 rounded-full mb-6" data-id="element-169">
              ⏰ PRECIO DE LANZAMIENTO — OFERTA POR TIEMPO LIMITADO
            </div>
            <CountdownTimer data-id="element-170" />
            <p className="text-red-600 font-medium mt-4" data-id="element-171">
              🔴 El precio sube cuando termina el contador
            </p>
            <h2 className="text-3xl font-bold mt-8 mb-2" data-id="element-172">Elegí tu Pack:</h2>
            <p className="text-gray-600" data-id="element-173">
              Todas las opciones incluyen los 6 Bonus
            </p>
          </div>

          {/* Selector de packs estilo checkout */}
          <div className="max-w-2xl mx-auto bg-white rounded-3xl shadow-xl border border-gray-100 p-5 sm:p-8" data-id="element-174">
            <div className="space-y-4" data-id="element-175">
              {PACKS.map(pack => {
              const isSelected = selectedPack === pack.id;
              return <button key={pack.id} type="button" onClick={() => setSelectedPack(pack.id)} aria-pressed={isSelected} className={`w-full text-left rounded-2xl border-2 p-4 sm:p-5 flex items-start gap-4 transition-all ${isSelected ? 'border-blue-600 bg-blue-50/60 shadow-md' : 'border-gray-200 bg-white hover:border-gray-300'}`} data-id="element-176">
                    {/* Radio */}
                    <span className={`mt-1 flex-shrink-0 w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${isSelected ? 'border-blue-600' : 'border-gray-300'}`} data-id="element-177">
                      {isSelected && <span className="w-3 h-3 rounded-full bg-blue-600" data-id="element-178" />}
                    </span>

                    {/* Contenido */}
                    <div className="flex-1 min-w-0" data-id="element-179">
                      <div className="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-2 sm:gap-3" data-id="element-180">
                        <div className="min-w-0" data-id="element-181">
                          {/* Fila título + precio (en mobile el precio va arriba a la derecha, sin chocar) */}
                          <div className="flex items-start justify-between gap-2 sm:block" data-id="element-182">
                            <div className="flex items-center gap-2 min-w-0" data-id="element-183">
                              <span className="text-xl sm:text-2xl flex-shrink-0" data-id="element-184">
                                {pack.icon}
                              </span>
                              <h3 className="text-sm sm:text-lg font-bold text-gray-900 leading-tight break-words" data-id="element-185">
                                {pack.name}
                              </h3>
                            </div>

                            {/* Precio en mobile */}
                            <div className="text-right flex-shrink-0 sm:hidden" data-id="element-186">
                              <div className="text-gray-400 line-through text-[11px] leading-none" data-id="element-187">
                                {pack.oldPrice}
                              </div>
                              <div className={`text-base font-extrabold leading-tight ${isSelected ? 'text-blue-700' : 'text-gray-900'}`} data-id="element-188">
                                {pack.price}
                              </div>
                            </div>
                          </div>

                          {pack.best && <div className="flex flex-wrap gap-2 mt-2" data-id="element-189">
                              <span className="bg-yellow-400 text-blue-900 text-xs font-bold px-2.5 py-0.5 rounded-full" data-id="element-190">
                                {pack.badge}
                              </span>
                              <span className="bg-green-100 text-green-700 text-xs font-bold px-2.5 py-0.5 rounded-full" data-id="element-191">
                                {pack.save}
                              </span>
                            </div>}
                          <p className="text-xs sm:text-sm text-gray-500 mt-2" data-id="element-192">
                            {pack.contents}
                          </p>
                        </div>

                        {/* Precio en desktop */}
                        <div className="hidden sm:block text-right flex-shrink-0" data-id="element-193">
                          <div className="text-gray-400 line-through text-sm" data-id="element-194">
                            {pack.oldPrice}
                          </div>
                          <div className={`text-3xl font-extrabold ${isSelected ? 'text-blue-700' : 'text-gray-900'}`} data-id="element-195">
                            {pack.price}
                          </div>
                        </div>
                      </div>
                    </div>
                  </button>;
            })}
            </div>

            {/* CTA dinámico */}
            <a href={activePack.checkoutUrl} className="w-full mt-6 py-5 rounded-2xl font-bold text-lg text-blue-900 bg-yellow-400 hover:bg-yellow-300 transition-colors shadow-lg shadow-yellow-400/30 flex flex-col items-center justify-center gap-1" data-id="element-196">
              {activePack.cta}
              <span className="text-xl" data-id="element-197">→</span>
            </a>

            <p className="text-center text-sm italic text-gray-500 mt-4" data-id="element-198">
              {activePack.note}
            </p>

            {/* Señales de confianza */}
            <div className="grid grid-cols-2 gap-4 mt-8 pt-6 border-t border-gray-100 text-sm text-gray-700" data-id="element-199">
              <div className="flex items-center gap-2" data-id="element-200">
                <ShieldCheck size={18} className="text-green-600" data-id="element-201" /> Pago seguro
              </div>
              <div className="flex items-center gap-2" data-id="element-202">
                <Zap size={18} className="text-yellow-500" data-id="element-203" /> Acceso en 5 min
              </div>
              <div className="flex items-center gap-2" data-id="element-204">
                <CheckCircle2 size={18} className="text-green-600" data-id="element-205" /> Garantía 7
                días
              </div>
              <div className="flex items-center gap-2" data-id="element-206">
                <CreditCard size={18} className="text-blue-600" data-id="element-207" /> Tarjeta ·
                Transferencia
              </div>
            </div>
          </div>

          {/* QUÉ AGREGA EL MEGAPACK ELITE */}
          <div className="mt-16 bg-gradient-to-r from-yellow-50 to-orange-50 rounded-3xl p-8 md:p-12 border border-yellow-200" data-id="element-208">
            <h3 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-209">
              ¿Qué agrega el Megapack Elite?
            </h3>
            <p className="text-gray-600 mb-8" data-id="element-210">
              Por solo $9.000 más, llevás tu enseñanza al siguiente nivel.
            </p>

            <div className="grid md:grid-cols-2 gap-8" data-id="element-211">
              <div className="bg-white p-6 rounded-2xl shadow-sm" data-id="element-212">
                <div className="text-3xl mb-4" data-id="element-213">🥅</div>
                <h4 className="font-bold text-lg mb-2" data-id="element-214">
                  Elite 1 — LA GUÍA 360 PARA EL ARQUERO
                </h4>
                <p className="text-gray-600 text-sm" data-id="element-215">
                  El manual definitivo para entrenar el puesto más olvidado y
                  más determinante de la cancha. Técnica, psicología,
                  micro-sesiones y evaluación por categoría. Nunca más tu
                  arquero entrando solo contra la pared.
                </p>
              </div>
              <div className="bg-white p-6 rounded-2xl shadow-sm" data-id="element-216">
                <div className="text-3xl mb-4" data-id="element-217">📋</div>
                <h4 className="font-bold text-lg mb-2" data-id="element-218">
                  Elite 2 — JUGADAS MAESTRAS DE 7VS6 Y SUPERIORIDADES
                </h4>
                <p className="text-gray-600 text-sm" data-id="element-219">
                  El pizarrón táctico que destrava partidos en el último minuto.
                  5 jugadas maestras, saques especiales y el guion exacto del
                  tiempo muerto. Nunca más quedarte sin palabras cuando el
                  partido aprieta.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECCIÓN 10 — COMPARATIVA DE VALOR */}
      <section className="py-24 px-4 bg-gray-900 text-white cv-auto" data-id="element-220">
        <div className="max-w-4xl mx-auto" data-id="element-221">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-222">
            ¿Cuánto cuesta NO tenerlo?
          </h2>

          <div className="bg-slate-800 rounded-3xl overflow-hidden" data-id="element-223">
            <div className="grid grid-cols-2 bg-slate-700 p-4 font-bold text-center" data-id="element-224">
              <div className="text-gray-300" data-id="element-225">SIN HANDBALL 360</div>
              <div className="text-orange-400" data-id="element-226">CON HANDBALL 360</div>
            </div>

            <div className="divide-y divide-slate-700" data-id="element-227">
              {[['2 horas planificando cada semana desde cero', '5 minutos. Todo listo.'], ['Sesiones sin hilo conductor ni progresión', '+728 sesiones resueltas con progresión real'], ['El arquero entrena solo contra la pared', 'Guía completa de arquero integrado al sistema'], ['Sin jugadas preparadas cuando el partido aprieta', 'Pizarrón táctico pro con 5 jugadas maestras listas'], ['Grupos sin sistema claro ni evaluación visible', 'Estructura clara para cada categoría y evaluación incluida'], ['Sensación de improvisar siempre', 'Llegás al entreno con todo resuelto']].map((row, idx) => <div key={idx} className="grid grid-cols-2 p-6 gap-4" data-id="element-228">
                  <div className="text-gray-400 flex items-start gap-3" data-id="element-229">
                    <X className="text-red-400 flex-shrink-0 mt-1" size={18} data-id="element-230" />
                    <span data-id="element-231">{row[0]}</span>
                  </div>
                  <div className="text-white font-medium flex items-start gap-3" data-id="element-232">
                    <CheckCircle2 className="text-green-400 flex-shrink-0 mt-1" size={18} data-id="element-233" />
                    <span data-id="element-234">{row[1]}</span>
                  </div>
                </div>)}
            </div>
          </div>

          <div className="text-center mt-12" data-id="element-235">
            <p className="text-xl text-gray-300 mb-8" data-id="element-236">
              El lunes podés improvisar o entrar con todo resuelto.
              <br data-id="element-237" />
              <span className="text-white font-bold" data-id="element-238">Vos decidís.</span>
            </p>
            <button onClick={scrollToPricing} className="bg-yellow-400 hover:bg-yellow-300 text-blue-900 font-bold text-lg py-4 px-8 rounded-xl transition-all transform hover:scale-105 shadow-lg shadow-yellow-400/20" data-id="element-239">
              QUIERO ENTRAR CON TODO RESUELTO
            </button>
          </div>
        </div>
      </section>

      {/* SECCIÓN 12 — TESTIMONIOS COMPLETOS */}
      <section className="py-24 px-4 bg-gray-50 cv-auto" data-id="element-240">
        <div className="max-w-4xl mx-auto" data-id="element-241">
          <div className="text-center mb-12" data-id="element-242">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-243">
              Lo que dicen los entrenadores
            </h2>
            <div className="flex items-center justify-center gap-2 text-xl font-bold text-gray-700" data-id="element-244">
              4.9/5 <Star className="text-yellow-400" fill="currentColor" data-id="element-245" />
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-6" data-id="element-246">
            {[{
            init: 'MP',
            name: 'Marcos P.',
            loc: 'Buenos Aires 🇦🇷',
            text: 'Compré un sábado. El domingo a la noche tenía el mes de entrenamientos listo. Nunca más improviso.'
          }, {
            init: 'CG',
            name: 'Claudia G.',
            loc: 'Córdoba 🇦🇷',
            text: 'Tres chicos de Cadetes que estaban estancados mejoraron su defensa en el primer mes con el Tomo 7.'
          }, {
            init: 'FR',
            name: 'Federico R.',
            loc: 'Rosario 🇦🇷',
            text: 'Antes tardaba 2 horas armando el entrenamiento de la semana. Ahora son 5 minutos.'
          }, {
            init: 'SV',
            name: 'Sofía V.',
            loc: 'Mendoza 🇦🇷',
            text: 'El Bonus de Scouting cambió cómo preparo los partidos. Ahora llego al banco con un plan real para cada rival.'
          }, {
            init: 'DA',
            name: 'Diego A.',
            loc: 'Santa Fe 🇦🇷',
            text: 'La Guía del Arquero me salvó. Mi portero mejoró más en 3 semanas que en todo el año anterior.'
          }, {
            init: 'LR',
            name: 'Laura R.',
            loc: 'Tucumán 🇦🇷',
            text: 'Las Jugadas Maestras cambiaron mis tiempos muertos. Antes no sabía qué decir. Ahora tengo el guion exacto.'
          }].map((t, idx) => <div key={idx} className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-247">
                <div className="flex text-yellow-400 mb-4" data-id="element-248">
                  {[...Array(5)].map((_, i) => <Star key={i} size={14} fill="currentColor" data-id="element-249" />)}
                </div>
                <p className="text-gray-700 italic mb-6" data-id="element-250">"{t.text}"</p>
                <div className="flex items-center gap-3 mt-auto" data-id="element-251">
                  <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center text-blue-700 font-bold text-sm" data-id="element-252">
                    {t.init}
                  </div>
                  <div data-id="element-253">
                    <div className="font-bold text-gray-900 text-sm" data-id="element-254">
                      {t.name}
                    </div>
                    <div className="text-xs text-gray-500" data-id="element-255">{t.loc}</div>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECCIÓN 13 — GARANTÍA */}
      <section className="py-16 px-4 bg-blue-900 text-white" data-id="element-256">
        <div className="max-w-3xl mx-auto text-center" data-id="element-257">
          <ShieldCheck size={64} className="mx-auto text-yellow-400 mb-6" data-id="element-258" />
          <h2 className="text-3xl font-bold mb-6" data-id="element-259">
            Garantía 7 días sin preguntas
          </h2>
          <p className="text-lg text-blue-100 mb-8 leading-relaxed" data-id="element-260">
            Abrí los 14 Tomos. Revisá los 6 Bonus. Usá los Ebooks Elite en tu
            entreno.
            <br data-id="element-261" />
            Si no es lo que esperabas → 100% de devolución.
            <br data-id="element-262" />
            Sin preguntas. Sin formularios. Sin drama.
          </p>
          <div className="inline-block bg-blue-800 px-6 py-2 rounded-full text-sm font-bold tracking-wider" data-id="element-263">
            TASA DE DEVOLUCIONES MENOR AL 2%
          </div>
        </div>
      </section>

      {/* SECCIÓN 14 — FAQ */}
      <section className="py-24 px-4 bg-white cv-auto" data-id="element-264">
        <div className="max-w-3xl mx-auto" data-id="element-265">
          <h2 className="text-3xl font-bold text-center mb-12 text-gray-900" data-id="element-266">
            Preguntas Frecuentes
          </h2>
          <div className="space-y-2" data-id="element-267">
            <FAQItem question="¿Cómo recibo el material?" answer="Inmediatamente después del pago recibís un email con el acceso a todos los PDFs. Podés verlos desde el celular, tablet o computadora. Sin apps adicionales." data-id="element-268" />
            <FAQItem question="¿Sirve si soy entrenador nuevo o si tengo experiencia?" answer="Sirve para los dos. Si sos nuevo: tenés la estructura que te falta. Si tenés experiencia: tenés el sistema para optimizar lo que ya hacés y ahorrar tiempo." data-id="element-269" />
            <FAQItem question="¿Los 6 Bonus están en las dos opciones?" answer="Sí. Los 6 Bonus están incluidos en los 3 packs sin excepción." data-id="element-270" />
            <FAQItem question="¿Qué diferencia hay con otros materiales que ya existen?" answer="Es el único sistema diseñado específicamente para la realidad del handball argentino: playones municipales, materiales limitados y múltiples categorías a cargo." data-id="element-271" />
            <FAQItem question="¿Sirve si tengo varias categorías a cargo?" answer="Es exactamente para eso. Cada tomo está diseñado para una categoría específica. Podés manejar Minis y Cadetes el mismo día con materiales distintos y específicos." data-id="element-272" />
            <FAQItem question="¿Qué pasa si no me sirve?" answer="Tenés 7 días de garantía total. Si no te sirve, te devolvemos el 100%. Sin preguntas y sin formularios." data-id="element-273" />
            <FAQItem question="¿Vale la pena el Megapack Elite si ya planifico bien mis clases?" answer="Si ya planificás bien, los 2 Ebooks Elite son el salto que te falta: el arquero entrenado con método y las jugadas tácticas avanzadas para ganar partidos cerrados. Son los dos contenidos que ningún otro material del mercado tiene." data-id="element-274" />
            <FAQItem question="¿Puedo pagar con tarjeta de crédito?" answer="Sí. Tarjeta de crédito, débito y transferencia bancaria. Pago seguro a través de Mercado Pago." data-id="element-275" />
          </div>
        </div>
      </section>

      {/* SECCIÓN 15 — CIERRE Y FOOTER */}
      <footer className="bg-blue-950 text-blue-200 py-16 px-4 text-center" data-id="element-276">
        <div className="max-w-4xl mx-auto" data-id="element-277">
          <div className="text-3xl mb-6" data-id="element-278">🤾</div>
          <h2 className="text-2xl font-bold text-white mb-2" data-id="element-279">HANDBALL 360</h2>
          <p className="mb-8" data-id="element-280">
            El sistema de planificación N°1 para entrenadores de handball
            argentinos.
          </p>

          <blockquote className="text-xl italic text-slate-300 mb-8 max-w-2xl mx-auto" data-id="element-281">
            "Porque preparar un buen entrenamiento no debería costarte todas las
            noches de la semana."
          </blockquote>

          <button onClick={scrollToPricing} className="w-full sm:w-auto bg-orange-500 hover:bg-orange-600 text-white font-bold text-base sm:text-lg py-4 px-10 rounded-2xl shadow-lg shadow-orange-500/30 transition-all transform hover:scale-[1.02] inline-flex items-center justify-center gap-2 mb-12" data-id="element-282">
            💪 QUIERO MI HANDBALL 360 AHORA →
          </button>

          <div className="grid sm:grid-cols-3 gap-4 text-sm mb-12 border-t border-slate-800 pt-12" data-id="element-283">
            <div data-id="element-284">📧 contacto@handball360.com.ar</div>
            <div data-id="element-285">📲 @handball360.ar</div>
            <div data-id="element-286">🌐 www.handball360.ar</div>
          </div>

          <div className="text-xs text-gray-600" data-id="element-287">
            <p data-id="element-288">© HANDBALL 360™ 2025. Todos los derechos reservados.</p>
            <p className="mt-2" data-id="element-289">
              Prohibida la reproducción y redistribución sin autorización
              expresa.
            </p>
          </div>
        </div>
      </footer>
    </div>;
}